import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin } from 'lucide-react';
import { usePhoneNumber } from '../hooks/usePhoneNumber';

export default function Contact() {
    const { t } = useTranslation();
    const { phoneNumber } = usePhoneNumber();

    return (
        <section id="contact" className="py-32 bg-white font-montserrat">
            <div className="container mx-auto px-4">
                <div className="text-center mb-20">
                    <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tighter mb-4 text-slate-900">{t('contact.title') || "Contact Us"}</h2>
                    <div className="h-1.5 w-24 bg-blue-600 mx-auto rounded-full" />
                </div>

                <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
                    {[
                        { icon: Phone, titleKey: 'phone', value: phoneNumber, subKey: 'available', defaultTitle: "Phone", defaultSub: "Available 24/7" },
                        { icon: Mail, titleKey: 'email', value: "bcntaxi247@gmail.com", subKey: 'reply', defaultTitle: "Email", defaultSub: "We reply within 24h" },
                        { icon: MapPin, titleKey: 'office', value: "Barcelona, Spain", subKey: 'hq', defaultTitle: "Office", defaultSub: "Central HQ" }
                    ].map((item, idx) => (
                        <div key={idx} className="group flex flex-col items-center text-center p-10 bg-white rounded-[32px] border border-slate-100 shadow-[0_20px_40px_-10px_rgba(0,0,0,0.05)] hover:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.1)] hover:-translate-y-1 transition-all duration-500">
                            <div className="w-16 h-16 bg-slate-50 text-blue-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white transition-all duration-500 shadow-inner">
                                <item.icon className="w-8 h-8" />
                            </div>
                            <h3 className="text-xl font-black uppercase tracking-tight mb-3 text-slate-900">{t(`contact.${item.titleKey}`) || item.defaultTitle}</h3>
                            <p className="text-slate-600 font-bold mb-2">{item.value}</p>
                            <p className="text-[10px] uppercase font-black tracking-widest text-slate-400 bg-slate-50 px-3 py-1 rounded-lg">
                                {t(`contact.${item.subKey}`) || item.defaultSub}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
